export default __webpack_public_path__ + "images/35dd647307a87dc0637ddfe886c5f198.png";